<mat-card class="height-100">
  <mat-card-header class="border-bottom">
    <mat-card-title>
      Adicionar Tabela de preço
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div class="mt-2 col-md-12">
      <mat-form-field class="width-100" appearance="outline">
        <mat-label>Nome</mat-label>
        <input matInput type="text" [formControl]="form.get('nome')" />
      </mat-form-field>
      <small
        class="p-error"
        *ngIf="
          form.get('nome').touched && form.get('nome').hasError('required')
        "
      >
        {{ messages.nome.required }}
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('nome').touched && form.get('nome').hasError('maxlength')
        "
      >
        {{ messages.nome.maxlength }}
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('nome').touched && form.get('nome').hasError('isEmptyValue')
        "
      >
        {{ messages.nome.isEmptyValue }}
      </small>
    </div>
    <!-- <div class="mt-2 col-md-12 mt-2">
      <mat-form-field class="w-100" appearance="outline" floatLabel="always">
        <mat-label>Acréscimo/Desconto</mat-label>
        <input
          class="text-right"
          matInput
          id="perc_desc_acresc"
          [formControl]="form.get('perc_desc_acresc')"
          (keydown)="validateNumbers($event)"
        />
        <span matSuffix>%</span>
      </mat-form-field>
      <small
        class="p-error"
        *ngIf="
          form.get('perc_desc_acresc').touched &&
          form.get('perc_desc_acresc').hasError('required')
        "
      >
        {{ messages.perc_desc_acresc.required }}
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('perc_desc_acresc').touched &&
          form.get('perc_desc_acresc').hasError('pattern')
        "
      >
        {{ messages.perc_desc_acresc.pattern }}
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('perc_desc_acresc').touched &&
          form.get('perc_desc_acresc').hasError('before_split')
        "
      >
        {{ messages.perc_desc_acresc.before_split }}
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('perc_desc_acresc').touched &&
          form.get('perc_desc_acresc').hasError('after_split')
        "
      >
        {{ messages.perc_desc_acresc.after_split }}
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('perc_desc_acresc').touched &&
          form.get('perc_desc_acresc').hasError('errorComma')
        "
      >
        {{ messages.perc_desc_acresc.errorComma }}
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('perc_desc_acresc').touched &&
          form.get('perc_desc_acresc').hasError('errorDots')
        "
      >
        {{ messages.perc_desc_acresc.errorDots }}
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('perc_desc_acresc').touched &&
          form.get('perc_desc_acresc').hasError('max_value')
        "
      >
        {{ messages.perc_desc_acresc.max_value }}
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('perc_desc_acresc').touched &&
          form.get('perc_desc_acresc').hasError('notNumbers')
        "
      >
        {{ messages.perc_desc_acresc.notNumbers }}
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('perc_desc_acresc').touched &&
          form.get('perc_desc_acresc').hasError('invalidNumber')
        "
      >
        {{ messages.perc_desc_acresc.invalidNumber }}
      </small>
    </div> -->
  </mat-card-content>
  <mat-card-actions>
    <div
      class="d-flex justify-content-between align-items-center w-100 flex-wrap mt-2 col-md-12"
    >
      <!-- <mat-slide-toggle
        id="field-atualizar-auto"
        color="primary"
        style="flex: 3;"
        [formControl]="form.get('atualizar_auto')"
      >
        Atualizar automaticamente
      </mat-slide-toggle> -->

      <div
        class="d-flex justify-content-between justify-content-md-start align-items-center mt-2"
        style="flex: 1;"
      >
        <button
          type="button"
          class="mr-md-2"
          mat-stroked-button
          id="cancel-btn"
          [matDialogClose]="undefined"
          [disabled]="loading"
        >
          Cancelar
        </button>
        <button
          id="save-btn"
          mat-raised-button
          color="primary"
          (click)="onSubmit()"
          [disabled]="!form.valid || loading"
        >
          Salvar
        </button>
      </div>
    </div>
  </mat-card-actions>
</mat-card>
